export function isStatusMessage(message) {
	if (!message) return false;
	const flag = message.isStatus;
	return (
		flag === true ||
		flag === 1 ||
		flag === "1" ||
		String(flag).toLowerCase() === "true"
	);
}

/** Ticket marcado como status no registro (aba Status). */
export function isStatusTicketRecord(ticket) {
	if (!ticket) return false;
	if (String(ticket.status || "").toLowerCase() === "status") {
		return true;
	}
	const flag = ticket.isStatus;
	return (
		flag === true ||
		flag === 1 ||
		flag === "1" ||
		String(flag).toLowerCase() === "true"
	);
}

/**
 * Ocultar da lista de chat (API): inclui legado pending com última msg story.
 */
export function isStatusTicket(ticket) {
	if (!ticket) return false;
	if (isStatusTicketRecord(ticket)) return true;
	return isStatusMessage(ticket.lastMessageObj);
}

export function belongsInTicketTab(ticket, tabStatus) {
	if (tabStatus === "status") {
		return isStatusTicketRecord(ticket);
	}
	return !isStatusTicketRecord(ticket);
}
